// extracted by mini-css-extract-plugin
export default {"loadingSpinnerWrapper":"ValidationConfirmSettlementPopup_loadingSpinnerWrapper__o+b02"};